@if (property(); as property) {
  <bxi-page [title]="pageTitle()" [breadcrumbOptions]="breadcrumbOptions()" [headerContent]="headerContent">
    <bx-card>
      <div class="gap-3xl p-3xl flex w-full content-start">
        <div class="gap-4xl flex flex-1">
          <div class="gap-lg flex items-start">
            <svg-icon key="building-05" fontSize="55px"></svg-icon>
            <div class="flex flex-col items-start">
              <bxi-attributes-panel [data]="basicInformation()"></bxi-attributes-panel>
            </div>
          </div>
        </div>
      </div>
    </bx-card>

    <bxi-property-product-status class="mt-8"></bxi-property-product-status>

    <bxi-property-status-matrix class="mt-8"></bxi-property-status-matrix>

    <bx-tab-group
      class="mt-8"
      [activeIndex]="0"
      [size]="'md'"
      [type]="'underline'"
      [fullWidth]="false"
      (activeTabChange)="activeTabId.set($any($event.tabId))"
    >
      <ng-template #devicesTitle>
        <span class="px-16">{{ 'property-details.tab.devices' | translate }}</span>
      </ng-template>
      <bx-tab [title]="devicesTitle" id="devices">
        @defer (when activeTabId() === 'devices') {
          <bxi-property-device-list class="mt-4xl"></bxi-property-device-list>
        }
      </bx-tab>

      <ng-template #topologyTitle>
        <span class="px-16">{{ 'property-details.tab.topology' | translate }}</span>
      </ng-template>
      <bx-tab [title]="topologyTitle" id="topology">
        @defer (when activeTabId() === 'topology') {
          <bxi-property-topology class="mt-4xl"></bxi-property-topology>
        }
      </bx-tab>

      <ng-template #gatewaysTitle>
        <span class="px-16">{{ 'property-details.tab.gateways' | translate }}</span>
      </ng-template>
      <bx-tab [title]="gatewaysTitle" id="gateways">
        @defer (when activeTabId() === 'gateways') {
          <bxi-property-gateway-list class="mt-4xl"></bxi-property-gateway-list>
        }
      </bx-tab>
    </bx-tab-group>
  </bxi-page>
}

<ng-template #headerContent>
  @if (propertyStatus(); as status) {
    <!-- The header row stretches its items by default, which would sit the badge at the top of the title's line box. -->
    <bxi-product-status-badge class="self-center" size="lg" [severity]="severityByStatus[status.overallStatus]"></bxi-product-status-badge>
  }
</ng-template>
